import { readFileAsDataURL } from '@corp/composables/file'
import { imageSizeFor } from '@corp/helpers/files'

export async function resizeImageFile (file: File, maxWidth?: number, maxHeight?: number) {
  const size = await imageSizeFor(file)

  if ((!maxWidth || size.width <= maxWidth) && (!maxHeight || size.height <= maxHeight))
    return file // No need to resize

  const dataUrl = await readFileAsDataURL(file)
  const img = await loadImage(dataUrl)

  const scale = Math.min((maxWidth || Infinity) / img.width, (maxHeight || Infinity) / img.height)
  const width = img.width * scale
  const height = img.height * scale

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  const ctx = canvas.getContext('2d')
  ctx!.drawImage(img, 0, 0, width, height)

  const blob = await canvasToBlob(canvas, file.type || 'image/jpeg', 0.9)

  return new File([blob], file.name, {
    type: file.type,
    lastModified: Date.now(),
  })
}

function loadImage (src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

function canvasToBlob (
  canvas: HTMLCanvasElement,
  type: string,
  quality: number,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob)
      else reject(new Error('Canvas toBlob failed'))
    }, type, quality)
  })
}
